@if (iconClass) {
<i [ngClass]="iconClass"
  [style.color]="iconColor"
  [attr.data-testid]="'vi-text-icon-' + text"></i>
}
<span class="vi-text"
  class="size-{{size}}"
  [style.color]="textColor"
  [style.font-weight]="fontWeight"
  [attr.aria-label]="text"
  [attr.title]="text"
  [attr.data-testid]="'vi-text-' + text">
  {{text}}
</span>
